import { useState } from 'react';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import ListingLibResolvedCell from 'framework-listing-lib/table/ListingLibResolvedCell';

//@ts-expect-error Missing types
import { COS_INDEX_CONNECTIONS_PARENTS } from 'reference-resolvers/constants/ReferenceObjectTypes';
import { Link } from 'foundations-components/transitional/components/Link';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { PROPERTIES } from 'FormsUI/components/dashboard/frameworkTable/constants';
import { FormType } from 'FormsUI/components/dashboard/frameworkTable/types';
import UnavailableNonHubSpotData from 'FormsUI/components/dashboard/frameworkTable/UnavailableNonHubSpotData';
import PageListDialog from 'FormsUI/components/dashboard/frameworkTable/CustomColumn/appearsOn/PageListDialog';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CustomCell = ({
  value,
  formName
}) => {
  const [showPageListModal, setShowPageListModal] = useState(false);
  const cosIndexObjects = value ? Object.values(value) : [];
  const label = cosIndexObjects.length ? /*#__PURE__*/_jsx(Link, {
    onClick: () => setShowPageListModal(true),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboard.frameworkTable.columns.appearsOn.places",
      options: {
        count: cosIndexObjects.length
      }
    })
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "dashboard.frameworkTable.columns.appearsOn.noPlaces"
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TruncateString, {
      children: label
    }), showPageListModal && /*#__PURE__*/_jsx(PageListDialog, {
      formName: formName,
      pages: cosIndexObjects,
      onCloseClick: () => setShowPageListModal(false)
    })]
  });
};
function AppearsOnCell({
  crmObject
}) {
  const formId = getPropertyValue(crmObject, PROPERTIES.FORM_ID);
  const name = getPropertyValue(crmObject, PROPERTIES.NAME);
  const formType = getPropertyValue(crmObject, PROPERTIES.FORM_TYPE);
  if (formType === FormType.CAPTURED) return /*#__PURE__*/_jsx(UnavailableNonHubSpotData, {});
  return /*#__PURE__*/_jsx(ListingLibResolvedCell, {
    CustomCell: CustomCell,
    extraCellProps: {
      formName: name
    },
    id: formId,
    objectType: COS_INDEX_CONNECTIONS_PARENTS
  });
}
export const appearsOn = {
  width: 175,
  sortable: false,
  renderCell: props => /*#__PURE__*/_jsx(AppearsOnCell, Object.assign({}, props))
};